import { Container, Row, Col} from "react-bootstrap";
import FormContact from "../components/FormContact"
import ContactCard from "../components/ContactCard"
function Contact() {
    const MyStyle =  {
        color: "white",
        fontSize: "3.5vmin"        
    }


    return (        
        <Container fluid style={{height: "100vh", backgroundColor: "#afc7c7"}}>
            <Row style={{margin: "0% 3% 3% 3%"}}>
                <Col style={{textAlign: "Center"}}>
                    <div style={MyStyle}>
                        <br/>
                        Leider haben wir bisher noch keinen Shop.<br/>
                        Senden Sie uns einfach eine Nachricht<br/>oder rufen Sie uns an<br/>wenn Sie Interesse
                        an einer MessageBox oder<br/>noch Fragen dazu haben.<br/>
                    </div>

                    <br/>
                    
                    <br/>
                    <div style={MyStyle}>
                        Wir werden uns umgehend bei Ihnen melden.<br/>
                        Vielen Dank.
                    </div>
                    <br/>
                    <br/>
                    <br/>

                    <div className="row justify-content-center">
                        <ContactCard />
                    </div>

                    <div>
                        {/*
                        <FormContact />
                        */}
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Contact;